import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Grid } from '@mui/material';
import {
  ControlledField,
  DateTimePickerInputField,
  getDateTimeShortFormatWithLocale,
} from 'remote/global';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useOperatorsRidesFinishMutation } from 'api/queries/operators';
import { ChangeRideEndSchemaType, changeRideEndSchema } from './types';

type Props = {
  onClose: () => void;
  defaultValues?: Partial<ChangeRideEndSchemaType>;
};

function ChangeRideEndForm(props: Props) {
  const { onClose, defaultValues } = props;
  const tInstance = useTranslation();
  const { t, i18n } = tInstance;

  const {
    handleSubmit,
    control,
    formState: { isSubmitting, isValidating, isLoading },
  } = useForm<ChangeRideEndSchemaType>({
    defaultValues: {
      newFinishTime: '',
      ...defaultValues,
    },
    resolver: zodResolver(changeRideEndSchema),
  });
  const ridesFinishMutation = useOperatorsRidesFinishMutation(String(defaultValues!.rideId));

  const onValid = async (data: ChangeRideEndSchemaType) => {
    await ridesFinishMutation.mutateAsync(data);
    onClose();
  };

  return (
    <form onSubmit={handleSubmit(onValid)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ControlledField
            control={control}
            name='newFinishTime'
            render={(renderProps) => (
              <DateTimePickerInputField
                {...renderProps}
                fieldProps={{
                  format: getDateTimeShortFormatWithLocale(i18n.language),
                }}
              />
            )}
          />
          <Button
            type='submit'
            variant='contained'
            disabled={isSubmitting || isValidating || isLoading}
            fullWidth
            sx={{ mt: '2rem' }}
          >
            {t('save')}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default ChangeRideEndForm;
